import React, { useEffect, useState } from "react"
import { Container, Form, Input, Label } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"
import { useMemo } from "react"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import "../../../assets/css/HolidayList/ListOfHolidays.css"
import AddHoliday from "../../../assets/images/Holiday/AddHoliday.jpg"
import EditHoliday from "../../../assets/images/Holiday/EditHoliday.jpg"
import { Table, Row, Col, Card, CardBody, Modal } from "reactstrap"
// common component
import Loader from "pages/Separate/Loader"
import swal from "sweetalert"
import Swal from "sweetalert2"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import moment from "moment"
import {
  fetchNodeData,
  FetchNodeDeleteData,
  FetchNodePostData,
  FetchNodePutData,
} from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import NewPagination from "components/Common/Newpagination"

function TableContainer({
  columns,
  data,
  toggleLoading,
  fetchHolidayData,
  setHoliday,
  setComment,
  setDate,
  date,
  comment,
  holiday,
}) {
  const [fixedContent, setFixedContent] = useState(false)
  const [addHoliday, setAddHoliday] = useState(false)
  const navigate = useNavigate()

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") setAddHoliday(false)
  })

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    setGlobalFilter,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  const addHolidayFunc = async e => {
    e.preventDefault()
    if (!holiday || !comment || !date) {
      Swal.fire("warning", "Please fill all the mandatory fields", "warning")
      return
    }
    const formDataEntries = {
      holiday: holiday,
      year: moment(date).format("YYYY"),
      comment: comment,
      date: date,
    }
    const response = await FetchNodePostData(
      toggleLoading,
      "holidays",
      secureLocalStorage.getItem("auth_token"),
      formDataEntries
    )

    if (response.data.success) {
      Swal.fire("Success", "Holiday added successfully", "success").then(() => {
        fetchHolidayData()
        setHoliday(null)
        setComment(null)
        setDate(null)
        setAddHoliday(false)
      })
    }
  }

  return (
    <div>
      {/* fixed buttons */}
      <div
        className={`flex-column fixed-buttons pt-2 mt-3 ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <Link className="btn btn-save  fix-btn btn-label pe-0">
          <i className="fas fa-plus me-2 icon-size label-icon"></i>
          <span>Add Holiday</span>
        </Link>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-red  fix-btn btn-label pe-0"
        >
          <i className="dripicons-cross me-2 icon-center label-icon"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-2">
        <Col>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <a
              className=" btn btn-save btn-label"
              onClick={() => setAddHoliday(true)}
            >
              <i className="fas fa-plus me-2 icon-size label-icon"></i>Add
              Holiday
            </a>
          </div>
        </Col>
      </Row>
      <div className="position-relative">
        <Table className="table table-bordered mt-4" {...getTableProps()}>
          <thead
            className={`${
              fixedContent ? "fix-holiday-header" : ""
            } fix-introducer-header`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                    {column.isInfoIcon ? (
                      <a
                        onClick={() => {
                          setNameModal(true)
                          setTitle(column.Header)
                        }}
                      ></a>
                    ) : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className="fix-introducer-header" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              return (
                <tr className="row-hover" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${
                          cell.column.className
                        }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
          previousPage={previousPage}
          nextPage={nextPage}
        />
      </Row>

      {/* Add Holiday Popup */}
      <Modal isOpen={addHoliday} size="xl" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">Add Holiday</h5>
          <button
            type="button"
            onClick={() => {
              setAddHoliday(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>

        <div className="modal-body pe-4">
          <Form
            className="row d-flex justify-content-center align-items-center"
            onSubmit={addHolidayFunc}
          >
            <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
              <div className="text-center">
                <img src={AddHoliday} alt="Addepe" style={{ width: "90%" }} />
              </div>
            </div>

            <div className="col-md-6 d-flex flex-column ">
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                <div className="col-md-8  ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Holiday Name <span className="text-danger">*</span>
                  </Label>
                  <div className="d-flex justify-content-start align-items-center gap-2">
                    <Input
                      type="text"
                      className="form-control"
                      placeholder="Enter Holiday Name"
                      onChange={e => setHoliday(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-4 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    className="form-control"
                    onChange={e => setDate(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="col-md-12 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Comment <span className="text-danger">*</span>
                  </Label>
                  <textarea
                    type="text"
                    // value={lead_belong}
                    placeholder="Add Comment Here.."
                    className="form-control"
                    onChange={e => setComment(e.target.value)}
                    style={{ height: "150px" }}
                  />
                </div>
              </div>

              <div className="my-4 text-end">
                <button className=" btn btn-save btn-label">
                  <i className="fas fa-save me-2 label-icon"></i>
                  Save
                </button>
                <a
                  className=" btn ms-md-2 btn-red btn-label"
                  onClick={() => {
                    setAddHoliday(false)
                  }}
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </a>
              </div>
            </div>

            {/* </div> */}
          </Form>
        </div>
      </Modal>
    </div>
  )
}

const ListOfHolidays = () => {
  const [holiday, setHoliday] = useState("")
  const [comment, setComment] = useState("")
  const [date, setDate] = useState("")
  const [allData, setAllData] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [modal_Access, setAccessDenied] = useState(false)
  const [editHoliday, setEditHoliday] = useState(false)
  const [editId, setEditId] = useState(null)
  const [data2, setData2] = useState([])

  const toggleLoading = isLoading => {
    setLoading(isLoading)
  }

  //meta title
  document.title = "List Of Holidays | Ambrella Consultancy"

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") setEditHoliday(false)
  })

  useEffect(() => {
    fetchHolidayData()
  }, [])

  const handleEditHoliday = holidayData => {
    setHoliday(holidayData.holiday)
    setComment(holidayData.comment)
    setDate(holidayData.date)
    setEditId(holidayData.id)
    setEditHoliday(true)
  }

  const onSubmitEdit = async e => {
    e.preventDefault()
    if (!holiday || !comment || !date) {
      Swal.fire("warning", "Please fill all the mandatory fields", "warning")
      return
    }
    const formDataEntries = {
      holiday: holiday,
      year: moment(date).format("YYYY"),
      comment: comment,
      date: date,
    }
    const response = await FetchNodePutData(
      toggleLoading,
      "holidays",
      editId,
      formDataEntries
    )

    if (response.data.success) {
      Swal.fire("Success", "Holiday edited successfully", "success").then(
        () => {
          fetchHolidayData()
          setHoliday(null)
          setComment(null)
          setDate(null)
          setEditHoliday(false)
        }
      )
    }
  }

  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        className: "text-center id_box",
      },
      {
        Header: () => {
          return <div>Holiday Name</div>
        },
        accessor: "holiday",
        grow: false,
        className: "festival_name_box",
      },

      {
        Header: () => <div style={{ textAlign: "center" }}>Date</div>,
        accessor: "date",
        isInfoIcon: true,
        className: "date_box",
        Cell: row => (
          <div style={{ textAlign: "center" }}>
            {row?.value ? moment(row?.value).format("DD-MM-YYYY") : "-"}
          </div>
        ),
      },
      {
        Header: () => <div style={{ textAlign: "center" }}>Day</div>,
        id: "day",
        accessor: "date",
        isInfoIcon: true,
        className: "day_box",
        Cell: ({ value }) => {
          if (!value) return <div style={{ textAlign: "center" }}>-</div>

          const dateObj = new Date(value)
          const dayName = dateObj.toLocaleDateString("en-US", {
            weekday: "long",
          })

          return <div style={{ textAlign: "center" }}>{dayName}</div>
        },
      },
      {
        Header: "Comment",
        accessor: "comment",
        isInfoIcon: true,
        className: "comment_box",
      },

      {
        Header: () => {
          return <div style={{ textAlign: "center" }}>Action</div>
        },
        accessor: "action",
        className: "text-center action_box",
        Cell: cellProps => {
          return (
            <div className="d-flex justify-content-center">
              <button
                onClick={() => handleEditHoliday(cellProps.row.original)}
                className="btn btn-sm me-1 btn-outline-secondary"
                title="Edit Holiday"
              >
                <i className="fa fa-pencil-alt"></i>
              </button>
              <button
                onClick={() => isDelete(cellProps.row.original.id)}
                className="btn btn-sm me-1 btn-outline-secondary"
                title="Delete Holiday"
              >
                <i className="fa fa-trash-alt text-danger"></i>
              </button>
            </div>
          )
        },
      },
    ],
    []
  )

  const isDelete = async id => {
    swal({
      title: "Are you sure?",
      text: "You want to Delete this Holiday !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willDelete => {
      if (willDelete) {
        setLoading(true)
        const formData = new FormData()
        const response = await FetchNodeDeleteData(
          toggleLoading,
          "holidays",
          id
        )
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            text: "Inventory deleted successfully!",
            confirmButtonText: "OK",
          }).then(() => {
            fetchHolidayData()
          })
        }
      }
    })
  }

  const fetchHolidayData = async id => {
    const response = await fetchNodeData(
      toggleLoading,
      "holidays",
      secureLocalStorage.getItem("auth_token")
    )

    if (response.data.success || response.success) {
      setData2(response.data.data || response.data)
    }
  }

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"Dashboard"}
            breadcrumbItem={"List Of Holidays"}
          />

          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={data2}
                      allData={allData}
                      setAllData={setAllData}
                      setAccessDenied={setAccessDenied}
                      setLoading={setLoading}
                      toggleLoading={toggleLoading}
                      fetchHolidayData={fetchHolidayData}
                      setHoliday={setHoliday}
                      setComment={setComment}
                      setDate={setDate}
                      date={date}
                      comment={comment}
                      holiday={holiday}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Edit Holiday Popup */}
      <Modal isOpen={editHoliday} size="xl" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">Edit Holiday</h5>
          <button
            type="button"
            onClick={() => {
              setEditHoliday(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>

        <div className="modal-body pe-4">
          <Form
            className="row d-flex justify-content-center align-items-center"
            onSubmit={onSubmitEdit}
          >
            <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
              <div className="text-center">
                <img src={EditHoliday} alt="Addepe" style={{ width: "90%" }} />
              </div>
            </div>

            <div className="col-md-6 d-flex flex-column ">
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                <div className="col-md-8  ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Holiday Name <span className="text-danger">*</span>
                  </Label>
                  <div className="d-flex justify-content-start align-items-center gap-2">
                    <Input
                      type="text"
                      className="form-control"
                      placeholder="Enter Holiday Name"
                      value={holiday}
                      onChange={e => setHoliday(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-4 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    className="form-control"
                    value={date}
                    onChange={e => {
                      setDate(e.target.value)
                    }}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="col-md-12 ps-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Comment <span className="text-danger">*</span>
                  </Label>
                  <textarea
                    type="text"
                    value={comment}
                    placeholder="Add Comment Here.."
                    className="form-control"
                    style={{ height: "150px" }}
                    onChange={e => setComment(e.target.value)}
                  />
                </div>
              </div>

              <div className="my-4 text-end">
                <button className=" btn btn-save btn-label">
                  <i className="fas fa-save me-2 label-icon"></i>
                  Save
                </button>
                <a
                  className=" btn ms-md-2 btn-red btn-label"
                  onClick={() => {
                    setEditHoliday(false)
                  }}
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </a>
              </div>
            </div>
          </Form>
        </div>
      </Modal>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default ListOfHolidays
